'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = exports.AudioResource = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createResource = require('./createResource');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioResource = exports.AudioResource = (0, _createResource.createResource)(function (src) {
  return new Promise(function (resolve, reject) {
    var audio = document.createElement('audio');
    audio.src = src;
    audio.onloadeddata = function () {
      return resolve(audio);
    };
    audio.onerror = reject;
    document.body.append(audio);
  });
});

var Audio = exports.Audio = function Audio(props) {
  AudioResource.read(props.src);
  return _react2.default.createElement('audio', props);
};